import React from 'react';
import logger from '../utils/logger';


class ErrorBoundary extends React.Component {
  constructor(props) {
    super(props);
    this.state = { hasError: false, errorMessage: '', errorStack: '' };
  }

  static getDerivedStateFromError(error) {
    return { hasError: true };
  }

  componentDidCatch(error, errorInfo) {
    logger.error('ERROR BOUNDARY - Component error:', error);
    logger.error('ERROR BOUNDARY - Error details:', errorInfo);
    
    // Store more detailed error information for display
    this.setState({
      errorMessage: error.message,
      errorStack: error.stack
    });
    
    // Log additional information about the current state
    try {
      const userProfile = localStorage.getItem('userProfile');
      console.log('ERROR BOUNDARY - User profile in localStorage:', 
        userProfile ? JSON.parse(userProfile) : 'Not found');
    } catch (e) {
      logger.error('ERROR BOUNDARY - Error parsing localStorage data:', e);
    }
  }

  render() {
    if (this.state.hasError) {
      return (
        <div className="p-4 bg-red-50 border border-red-200 rounded-lg">
          <h2 className="text-xl font-bold text-red-700">Something went wrong</h2>
          <p>There was an error loading the component. Please try again later.</p>
          <div className="mt-4 p-2 bg-white rounded border border-red-100 text-xs overflow-auto max-h-40">
            <p className="font-bold">Error: {this.state.errorMessage}</p>
            <pre className="mt-2 whitespace-pre-wrap">{this.state.errorStack}</pre>
          </div>
        </div>
      );
    }

    return this.props.children;
  }
}

export default ErrorBoundary;
